/**
 * Public app config for the launch-time version gate. Plain axios — unauthenticated,
 * runs before/independent of login.
 */
import axios from 'axios';

const API_URL = import.meta.env.VITE_API_URL;

export interface AppConfig {
  min_version: { ios: string; android: string };
  recommended_version: { ios: string; android: string };
  store_url: { ios: string; android: string };
}

export const getAppConfig = async (): Promise<AppConfig> => {
  const response = await axios.get(`${API_URL}/app-config`);
  return response.data as AppConfig;
};
